var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "-1.4 -1.4 16.80 16.80",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.00014,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5.108323,2.6602375 3.8001485,0 0,8.6486495 -3.8001485,0 z M 13,12.574907 l 0,-5.5749095 0,-5.57489 c 0,-0.19298 -0.20155,-0.31974 -0.375498,-0.23616 l -3.124192,1.50138 0,4.30966 0,4.3096895 3.124205,1.50136 C 12.79845,12.894637 13,12.767877 13,12.574907 Z m -11.6245022,0.23615 3.1242053,-1.50138 0,-4.3096795 0,-4.30967 -3.1242053,-1.50138 C 1.2015633,1.1053575 1,1.2321175 1,1.4251075 l 0,5.57489 0,5.5749095 c 0,0.19297 0.2015633,0.31973 0.3754978,0.23615 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPano);
export default __webpack_public_path__ + "static/media/pano.e83112ca4aedca759de80c81d267ac73.svg";
export { ForwardRef as ReactComponent };